import { useAdminAuthStore } from '@/store/admin-auth.store';
import { tokenManager } from '@/utils/token-manager';
import { Navigate, Outlet } from 'react-router-dom';

export function AdminGuard() {
  const { isAuthenticated, user } = useAdminAuthStore();
  const hasToken = !!tokenManager.getTokens()?.accessToken;

  if (!isAuthenticated && !hasToken) {
    return <Navigate to="/login" replace />;
  }

  if (user && user.role !== 'super_admin' && user.role !== 'admin') {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
}
